<template>
  <div class="i-quiz-progress">
    <div
      class="fill"
      :style="{ width: percent + '%' }"
    ></div>
  </div>
</template>

<script setup>
defineProps({
  percent: { type: Number, default: 0 }
})
</script>

<style lang="scss" scoped>
.i-quiz-progress {
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  z-index: 99;
  height: 3px;
  background: #11182714;

  @include respond-to($breakpoint-md) {
    top: 56px;
  }

  .fill {
    height: 100%;
    background: $amber-mid;
    transition: width 0.6s cubic-bezier(0.22, 1, 0.36, 1);
  }
}
</style>
